import React from "react";

export default function ProductArtwork({
  src,
  width,
  height,
  alt,
  priority = false,
  className = "",
}) {
  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={["h-auto w-full max-w-full object-contain", className].join(" ")}
      loading={priority ? "eager" : "lazy"}
      fetchPriority={priority ? "high" : "auto"}
      decoding={priority ? "sync" : "async"}
      draggable={false}
    />
  );
}
